export default {
	properties: [
		{
			text: 'Porcentaje',
			key: 'percentage',
			type: 'text',
			is_title: true,
			use_in_select: true,
		},
	],
	singular_model_name_spanish: 'Iva',
	plural_model_name_spanish: 'Ivas',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}